import { TWPERMISSIONS } from 'dataSource/auth/types'

// Exact page paths
export const pageRoutes = {
  THRIVEWORKS_HOME: '/',
  LOGIN: '/app/login',
  MAGIC_LOGIN: '/login?redirect=true',
  PROVIDER_SEARCH: '/app/providers',
  PRE_SEARCH_QUESTIONNAIRE: '/app/search-questionnaire',
  ADVERTISEMENT_QUESTIONNAIRE: '/app/get-started-questionnaire',
  PROVIDER_PROFILE: '/app/providers/us',
  BOOKING: '/app/bookings',
  BOOKING_SUPPORT_EMAIL: '/app/bookings/support/email',
  BOOKING_SUPPORT_CONFIRM_CONSENT: '/app/bookings/support/patient-info',
  BOOKING_SUPPORT_PAYMENT: '/app/bookings/support/payment',
  BOOKING_USER_CONFIRM_CONSENT: '/app/bookings/user/patient-info',
  BOOKING_USER_PAYMENT: '/app/bookings/user/payment',
  INSURANCE_MANAGEMENT: '/insurance-management',
  DASHBOARD_USER_HOME: '/app/patient/dashboard/home',
  DASHBOARD_USER_SESSIONS: '/app/patient/dashboard/sessions',
  DASHBOARD_USER_SESSIONS_UPCOMING: '/app/patient/dashboard/sessions/upcoming',
  DASHBOARD_USER_SESSIONS_PAST: '/app/patient/dashboard/sessions/past',
  DASHBOARD_USER_BILLING: '/app/patient/dashboard/billing',
  DASHBOARD_USER_INSURANCE_CARDS: '/app/patient/dashboard/insurance-cards',
  DASHBOARD_USER_BILLING_SESSION: '/app/patient/dashboard/billing/session',
  DASHBOARD_USER_ACCOUNT: '/app/patient/dashboard/account',
  DASHBOARD_USER_ACCOUNT_SETTINGS: '/app/patient/dashboard/account/settings',
  DASHBOARD_USER_ACCOUNT_PATIENT_DETAILS:
    '/app/patient/dashboard/account/patient_details',
  DASHBOARD_USER_FIRESIDE: '/app/patient/dashboard/fireside',
  DASHBOARD_USER_INSURANCE_CARD_CAPTURE: '/app/patient/insurance-card-capture',
  DASHBOARD_USER_NEXT_YEAR_INSURANCE_CARD_CAPTURE:
    '/app/patient/next-year-insurance-card-capture',
  DASHBOARD_USER_MEDICARE_CARD_UPDATE_CAPTURE:
    '/app/patient/medicare-card-update-capture',
  DASHBOARD_SUPPORT: '/app/support/dashboard',
  DASHBOARD_SUPPORT_USER: '/app/support/dashboard/user',
  DASHBOARD_SUPPORT_USER_SESSION: '/app/support/dashboard/user/session',
  DASHBOARD_SUPPORT_USER_ACCOUNT_NOT_FOUND:
    '/app/support/dashboard/useraccountnotfound',
  DASHBOARD_SUPPORT_USER_CHECK_INSURANCE_CARD_CAPTURE:
    '/app/support/dashboard/check-insurance',
  VERIFY_SUCCESS: '/app/verify_success',
  VERIFY_USER_CONSENT: '/app/verify-user-consent',
  VERIFY_CARD: '/app/verify/consent',
  VERIFY_USER_PAYMENT: '/app/verify-user-payment',
  FIRST_TIME_USER: '/app/first-time-user',
  FIRST_TIME_AMD_USER: '/app/first-time-amd-user',
  PAGE_NOT_FOUND: '/app/404', // Page doesn't actual exists
  UNDER_MAINTENANCE: '/app/under-maintenance',
  B2B_VERIFICATION_SUCCESS: '/app/partners/verificationsuccess',
  LOGIN_EMAIL_SENT: '/login/email-sent',
  LOGIN_VERIFY_OTP: '/login/verify-otp',
  LOGIN_DASHBOARD: '/login/dashboard',
  B2B_PARTNER_DIRECTORY: '/app/partners',
  VERIFY_USER_IDENTITY: '/app/bookings/verify-user',
  AGENDA: '/agenda',
  AGENDA_DASHBOARD: '/agenda/dashboard',
  AGENDA_AMD: '/agenda/amd',
  AGENDA_AMD_DASHBOARD: '/agenda/amd-dashboard',
  FORMSORT: '/app/formsort',
  REDALERT: '/app/support/dashboard/red-alert',
  SYNC_AUDIT: '/app/support/dashboard/red-alert/sync-audit',
  RED_ALERT_ADVANCED: '/red-alert',
  COE_DASHBOARD: '/coe-dashboard',
  CARE_ADMIN: '/care/admin',
  CARE_MESSAGE: '/care/message',
  CARE_RCD: '/care/rcd',
  CARE_RCD_PIPELINE: '/care/rcd/pipeline',
  CARE_RCD_ROSTER: '/care/rcd/roster',
  CARE_RCD_INTAKE_RECOMMENDATIONS: '/care/rcd/intake-recommendations',
  CARE_RCD_PRACTICE_AVAILABILITY: '/care/rcd/practice-availability',
  CARE_RCD_PROVIDER_REQUESTS: '/care/rcd/provider-requests',
  OPEN_ENROLLMENT: '/open-enrollment',
  CARD_VIEWER: '/internal/insurance-card-viewer',
  // new booking flow routes
  NEW_BOOKING_ERROR: '/booking-error',
  NEW_BOOKING_BASE_URL: '/bookings/new',
  // Book next available (blind booking) flow
  BOOK_NEXT_AVAILABLE: '/book-next-available',
  PARTNER_PORTAL_DASHBOARD: '/partner-portal/dashboard',
  PARTNER_PORTAL_LOGIN: '/partner-portal/login',
}

// Se-Friendly routes
export const seFriendlyPageRoutes = {
  SE_FRIENDLY: '/se-friendly/',
  SE_FRIENDLY_THERAPISTS_HUB: '/se-friendly/therapists',
  SE_FRIENDLY_PSYCHIATRISTS_HUB: '/se-friendly/psychiatrists',
}

// ThriveCare routes
export const thriveCareV1PageRoutes = {
  THRIVECARE_V1_MBC_DASHBOARD: '/care/v1/mbc/dashboard',
  THRIVECARE_V1_CLIENT_LIST: '/care/v1/clients',
  THRIVECARE_V1_MY_SCHEDULE: '/care/v1',
  THRIVECARE_V1_CLIENT_DETAIL: (encryptedLicenseKeyEhrId: string): string =>
    `/care/v1/client-info/${encryptedLicenseKeyEhrId}`,
  THRIVECARE_REFERRALS: '/care/v1/referrals',
  THRIVECARE_MAKE_REFERRAL: '/care/v1/referrals/make',
  THRIVECARE_REFERRAL_DONE: '/care/v1/referrals/make/done',
  THRIVECARE_TASKS: '/care/v1/tasks',
  THRIVECARE_CALENDAR: '/care/v1/calendar',
  THRIVECARE_CALENDAR_SETTINGS: '/care/v1/calendar/settings',
  THRIVECARE_VIDEO_CALL: (sessionId: string): string =>
    `/care/v1/video/call/${sessionId}`,
  THRIVECARE_VIDEO_WAITING: (sessionId: string): string =>
    `/care/v1/video/waiting/${sessionId}`,
  THRIVECARE_MAINTENANCE: '/care/maintenance',
  THRIVECARE_NENA: '/care/v1/nena',
  THRIVECARE_REPORTS: '/care/v1/reports',
  THRIVECARE_ASSISTANT: '/care/v1/assistant',
}

// These are the routes that users will be sent to after login and if they
// try to access a page they didn't have access to
export const homePageRoutes = {
  [TWPERMISSIONS.CLINICIAN]: thriveCareV1PageRoutes.THRIVECARE_V1_MY_SCHEDULE,
  [TWPERMISSIONS.SUPPORT]: pageRoutes.DASHBOARD_SUPPORT,
  [TWPERMISSIONS.DEVOPS_ADMIN]: pageRoutes.DASHBOARD_SUPPORT,
  [TWPERMISSIONS.THIRD_PARTY_SUPPORT]: pageRoutes.PROVIDER_SEARCH,
  [TWPERMISSIONS.CLINICAL_ADMIN]: pageRoutes.LOGIN_DASHBOARD,
  [TWPERMISSIONS.ENTERPRISE_PARTNERSHIPS_ADMIN]: '/red-alert/partner-portal',
}
// Parent path which catches all its subpath
export const catchAllPageRoutes = {
  DASHBOARD_USER: '/app/patient/dashboard/[...page]',
  DASHBOARD_FIRESIDE: `${pageRoutes.DASHBOARD_USER_FIRESIDE}/[...coursedetail]`,
}

export const internalPageRoutes = {
  PHOTO_UPLOAD: '/internal/photo-upload',
  TESTIMONIALS: '/internal/testimonials',
  SLOT_EXPLAINER: '/internal/slot-explainer',
}

export const redAlertPageRoutes = {
  RED_ALERT: '/red-alert',
  AUDIT_SYNC: '/red-alert/audit-sync',
  ACCOUNT_LINKING: '/red-alert/account-linking',
  PATIENT_DETAILS: '/red-alert/patient/',
  APPOINTMENT_DETAILS: '/red-alert/appointment/',
  TICKETS: '/red-alert/tickets/',
  PERMISSION_CHECKER: '/red-alert/permissions-checker',
  SESSION_MANAGER: '/red-alert/session-manager',
  CROSS_STATE_ANALYSIS: '/red-alert/cross-state-analysis',
  SLOT_COMPARISON: '/red-alert/slot-comparison',
  PARTNER_PORTAL_USERS: '/red-alert/partner-portal',
  PARTNER_PORTAL_DASHBOARD: '/red-alert/partner-portal/dashboard',
  BUSINESS_PARTNER_REASSIGNMENT: '/red-alert/business-partner-reassignment',
}

export const careAdminRoutes = {
  TASK_DETAILS_PAGE: (taskConfigId: string): string =>
    `${pageRoutes.CARE_ADMIN}/${taskConfigId}`,
  NEW_TASK_PAGE: `${pageRoutes.CARE_ADMIN}/new`,
  EDIT_TASK_PAGE: (taskConfigId: string): string =>
    `${pageRoutes.CARE_ADMIN}/${taskConfigId}/edit`,
}
